import React from "react";
import "../Styles/ProductPage.css";

// Read only list of the stores a coupon / deal has already been copied to
// (the API's `linked_stores`). They are NOT part of the copy to store
// selection — `onCopyAll` drops all of them into it in one click.
const LinkedStoresSection = ({
  title = "Already copied to stores",
  stores = [],
  onCopyAll,
  copyAllLabel = "Add all to copy to store",
  allCopiedLabel = "All added",
  allCopied = false,
}) => {
  if (!stores?.length) return null;

  return (
    <div className="qv-linked-stores mb-6">
      <div className="title-area items-center flex">
        <div className="CircularSTDMedium-16px">{title}</div>
        {typeof onCopyAll === "function" ? (
          <button
            type="button"
            className="qv-linked-stores__action"
            onClick={onCopyAll}
            disabled={allCopied}
          >
            {allCopied ? allCopiedLabel : copyAllLabel}
          </button>
        ) : (
          ""
        )}
      </div>
      <div className="selected-item qv-linked-stores__list">
        {stores.map((store) => (
          <div className="item" key={store?.id ?? store?.merchant_id}>
            <span>{store?.name}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LinkedStoresSection;
